import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useNotifications} from "common/src/hooks/notification/notificationHook";
import {useNavigate} from "react-router-dom";
import {useTable} from "common/src/hooks/table/tableHook";
import PromiseBuilder from "common/src/utils/PromiseUtils";
import apiClient from "common/src/api/ApiClient";
import Table from "common/src/components/widget/Table";
import TablePagination from "common/src/components/widget/TablePagination";
import TableFilter from "common/src/components/widget/TableFilter";
import {dateToLocalizedFormat} from "common/src/utils/DateUtils";
import {offerStatus} from "../../../model/offerStatus";
import {toEuroCurrency} from "common/src/utils/CurrencyUtils";


function OfferList() {
  const {t} = useTranslation();

  const {addErrorNotification} = useNotifications();
  const navigate = useNavigate();
  const [elements, setElements] = useState([]);
  const [totalElements, setTotalElements] = useState(null);



  const offerStatusList = offerStatus();

  const {
    selection,
    onSelection,
    page,
    onPage,
    sort,
    onSort,
    onFilter,
    filter,
  } = useTable({page: 0, filter: filter, total: totalElements,
    data: elements,
    sort: 'sort=dateCreated,desc'}, onRowClick, fetchData);

  function onRowClick(entry) {
    typeof(onClick) !== 'undefined' ? onClick() : navigate("edit/" + entry.id);
  }

  function fetchData(page, filter, sort) {
    new PromiseBuilder()
      .then(() => apiClient.get(`/api/v1/booking/offer`, null, page, filter, sort))
      .then((res) => {
        const data = res.data.payload;
        setElements(data.content);
        setTotalElements(data.totalElements);
      })
      .catch((res) => addErrorNotification(t("toast.fetch_failed_code", {code: res.code}), t("toast.error")))
      .run();
  }

  return (
  <div>
    <div className={"card table-card"}>
      <div className={"card-content"}>
        <Table
          columns={[
            {name: t('offer.date_created'), id: "dateCreated", cellComponent: (offer) => <div>{dateToLocalizedFormat(offer.dateCreated)}</div>},
            {name: t('offer.guest.name'), id: "guest.name", cellComponent: (offer) => <div>{offer.guest.name}</div>},
            {name: t('offer.guest.surname'), id: "guest.surname", cellComponent: (offer) => <div>{offer.guest.surname}</div>},
            {name: t('offer.start_date'), id: "startDate", cellComponent: (offer) => <div>{dateToLocalizedFormat(offer.startDate)}</div>},
            {name: t('offer.end_date'), id: "endDate", cellComponent: (offer) => <div>{dateToLocalizedFormat(offer.endDate)}</div>},
            {name: t('offer.confirmed_price'), id: "confirmedPrice", cellComponent: (offer) => <div>{offer.confirmedPrice ? toEuroCurrency(offer.confirmedPrice) : "/"}</div>},
            {name: t('offer.status.status'), id: "status",
              cellComponent: (offer) => <div className={"tag is-rounded " + offerStatusList.find(c => c.id === offer.status).className}>
                {offerStatusList.find(c => c.id === offer.status).name}
              </div>},
            {name: t('offer.modified'), id: "lastModified", cellComponent: (offer) => <div>{dateToLocalizedFormat(offer.lastModified)}</div>},
            {name: t('offer.modified_by'), id: "modifiedBy", cellComponent: (offer) => <div>{offer.modifiedBy}</div>},
          ]}
          data={elements}
          onSelection={onSelection}
          selection={selection}
          onSort={onSort}
          sort={sort}
        />

      <TablePagination
        page={page.page}
        total={page.total}
        pageSize={page.size}
        onPage={onPage}
        className={"mt-4"}
      />
      </div>
    </div>
      <div className={"level-right m-2"}>
        <TableFilter columns={[
          {id: "dateCreated", type: "date", name: 'request.date_created'},
          {id: "startDate", type: "date", name: 'offer.start_date'},
          {id: "endDate", type: "date", name: 'offer.end_date'},
          {id: "status", type: "select", options: offerStatusList, name: t('offer.status.status')},
          {id: "modifiedBy", type: "string", name: t('offer.modified_by')},
        ]} filter={filter} onFilter={onFilter}/>
      </div>
  </div>
  );
}

export default OfferList;
